import { supabase } from '../config/supabase';

const FEMALE_NAME_HINTS = new Set([
  'fatima', 'layla', 'sophie', 'emma', 'aisha', 'mary', 'maria', 'anna', 'sarah',
  'noor', 'mariam', 'hala', 'noura', 'amira', 'lina', 'dina', 'yasmin', 'zahra',
]);

const MALE_NAME_HINTS = new Set([
  'ahmed', 'omar', 'hassan', 'james', 'luca', 'pierre', 'mohammed', 'mohammad',
  'ali', 'khalid', 'saeed', 'youssef', 'abdullah', 'sultan', 'rashid', 'hamad',
]);

export function normalizePainMapGender(value) {
  if (!value || typeof value !== 'string') {
    return null;
  }

  const normalized = value.trim().toLowerCase();

  if (['f', 'female', 'woman', 'women', 'girl'].includes(normalized)) {
    return 'woman';
  }

  if (['m', 'male', 'man', 'men', 'boy'].includes(normalized)) {
    return 'man';
  }

  return null;
}

export function inferPainMapGenderFromName(patientName) {
  if (!patientName || typeof patientName !== 'string') {
    return null;
  }

  const firstName = patientName.trim().split(/\s+/)[0]?.toLowerCase();
  if (!firstName) {
    return null;
  }

  if (FEMALE_NAME_HINTS.has(firstName)) {
    return 'woman';
  }

  if (MALE_NAME_HINTS.has(firstName)) {
    return 'man';
  }

  return null;
}

export async function fetchPainMapGenderFromMedicalRecords(emiratesId) {
  if (!emiratesId) {
    return null;
  }

  try {
    const { data, error } = await supabase
      .from('AiDoctor')
      .select('gender')
      .eq('emiratesId', emiratesId)
      .order('appointmentDate', { ascending: false })
      .limit(20);

    if (error) {
      console.warn('Could not load patient gender from medical records:', error.message);
      return null;
    }

    for (const record of data || []) {
      const gender = normalizePainMapGender(record?.gender);
      if (gender) {
        return gender;
      }
    }
  } catch (err) {
    console.warn('Failed to resolve patient gender from medical records:', err);
  }

  return null;
}

export function resolvePainMapGender({ medicalGender, patientName }) {
  return (
    normalizePainMapGender(medicalGender) ||
    inferPainMapGenderFromName(patientName) ||
    'man'
  );
}
